<template>
  <basic-dialog :show="show" @close="$emit('close')" max-width="900">
    <template v-slot:title>{{ editorTitle }}</template>
    <v-row>
      <v-col>
        <v-select
          label="Note Type"
          :outlined="outlinedInputs"
          hide-details
          :items="noteTypes"
          item-text="name"
          item-value="code"
          v-model="code"
          @change="onNoteTypeChange"
        />
      </v-col>
      <v-col>
        <v-select
          label="Supplier"
          :outlined="outlinedInputs"
          hide-details
          v-model="selectedSuppliers"
          :items="suppliers"
          item-text="name"
          item-value="id"
          multiple
        />
      </v-col>
    </v-row>
    <v-row
      ><v-col
        ><v-text-field
          v-model="name"
          label="Name"
          :outlined="outlinedInputs"
          hide-details
        ></v-text-field></v-col
    ></v-row>
    <v-row>
      <v-col>
        <vue-editor v-model="content" label="Content"></vue-editor>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="py-0">
        <v-checkbox label="Confirm Email" v-model="forConfirm" hide-details />
      </v-col>
      <v-col class="py-0">
        <v-checkbox
          label="Amendment Email"
          v-model="forAmendment"
          hide-details
        />
      </v-col>
      <v-col class="py-0">
        <v-checkbox label="Cancel Email" v-model="forCancel" hide-details />
      </v-col>
      <v-col class="py-0">
        <v-checkbox
          label="Client Email"
          v-model="forContactClient"
          hide-details
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col class="py-0"
        ><v-checkbox label="For Web" v-model="forWeb" hide-details
      /></v-col>
      <v-col class="py-0"
        ><v-checkbox label="For Quotation" v-model="forQuotation" hide-details
      /></v-col>
      <v-col class="py-0"
        ><v-checkbox
          label="For Confirmation"
          v-model="forConfirmation"
          hide-details
      /></v-col>
      <v-col class="py-0"
        ><v-checkbox label="For Voucher" v-model="forVoucher" hide-details
      /></v-col>
    </v-row>
    <v-row>
      <v-col class="py-0"
        ><v-checkbox label="For Other" v-model="forOther" hide-details /></v-col
    ></v-row>
    <template v-slot:actions>
      <v-btn
        v-if="!readOnly"
        color="primary"
        @click="onSave"
        :disabled="!isValid"
        >Save</v-btn
      >
    </template>
    <v-row v-if="debug">
      <v-col
        ><code>{{ code }}</code></v-col
      >
    </v-row>
  </basic-dialog>
</template>

<script>
import { VueEditor } from "vue2-editor";
import gql from "graphql-tag";
import BasicDialog from "../../shared/BasicDialog.vue";
import { removeGQLTypename } from "../../../../helpers";
const LIST_QUERY = gql`
  query allSupplierItineraryNoteTypes {
    supplierItineraryNoteTypes {
      edges {
        node {
          id
          name
          code
          description
          content
          forContactClient
          forConfirm
          forConfirmation
          forAmendment
          forCancel
          forQuotation
          forVoucher
          forOther
          forWeb
        }
      }
    }
  }
`;
export default {
  name: "supplier-iti-note-edit-dialog",

  props: {
    show: {
      type: Boolean,
      default: () => false,
    },
    value: {
      type: Object,
      default: () => null,
    },
    suppliers: {
      type: Array,
      default: () => [],
    },
    readOnly: {
      type: Boolean,
      default: () => false,
    },
  },

  components: { BasicDialog, VueEditor },

  data() {
    return {
      debug: false,
      name: this.value ? this.value.name : "New Note",
      code: this.value ? this.value.code : "",
      selectedSuppliers: this.value ? [...this.value.supplierIds] : [],
      content: this.value ? this.value.content : "",
      forConfirm: this.value ? this.value.forConfirm : false,
      forConfirmation: this.value ? this.value.forConfirmation : false,
      forAmendment: this.value ? this.value.forAmendment : false,
      forContactClient: this.value ? this.value.forContactClient : false,
      forCancel: this.value ? this.value.forCancel : false,
      forQuotation: this.value ? this.value.forQuotation : false,
      forVoucher: this.value ? this.value.forVoucher : false,
      forOther: this.value ? this.value.forOther : false,
      forWeb: this.value ? this.value.forWeb : false,
    };
  },

  computed: {
    editorTitle() {
      return `${this.value && this.value.id ? "Edit" : "Add"} - ${this.name}`;
    },
    isValid() {
      return (
        this.name &&
        this.name != "" &&
        this.content != "" &&
        this.selectedSuppliers.length > 0 &&
        this.code != ""
      );
    },
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    noteTypes() {
      return this.supplierItineraryNoteTypes &&
        this.supplierItineraryNoteTypes.edges
        ? this.supplierItineraryNoteTypes.edges.map(removeGQLTypename)
        : [];
    },
  },

  watch: {
    value(newVal) {
      this.name = newVal ? newVal.name : "New Note";
      this.code = newVal ? newVal.code : "";
      this.content = newVal
        ? newVal.content
        : "New Supplier Itinerary Note Content";
      this.selectedSuppliers = newVal ? [...newVal.supplierIds] : [];
      this.forConfirm = newVal ? newVal.forConfirm : false;
      this.forConfirmation = newVal ? newVal.forConfirmation : false;
      this.forAmendment = newVal ? newVal.forAmendment : false;
      this.forContactClient = newVal ? newVal.forContactClient : false;
      this.forCancel = newVal ? newVal.forCancel : false;
      this.forQuotation = newVal ? newVal.forQuotation : false;
      this.forVoucher = newVal ? newVal.forVoucher : false;
      this.forOther = newVal ? newVal.forOther : false;
      this.forWeb = newVal ? newVal.forWeb : false;
    },
  },

  methods: {
    onSave() {
      this.$emit("input", {
        id: this.value && this.value.id ? this.value.id : undefined,
        name: this.name,
        code: this.code,
        content: this.content,
        forConfirm: this.forConfirm,
        forConfirmation: this.forConfirmation,
        forAmendment: this.forAmendment,
        //forContactClient: this.forContactClient,
        forCancel: this.forCancel,
        forQuotation: this.forQuotation,
        forVoucher: this.forVoucher,
        forOther: this.forOther,
        forWeb: this.forWeb,
        supplierIds: [...this.selectedSuppliers],
      });
    },
    onNoteTypeChange(payload) {
      const selectedType = this.noteTypes.find((t) => t.code == payload);
      if (selectedType) {
        this.name = selectedType.name;
        this.content = selectedType.content;
        this.forConfirm = selectedType.forConfirm;
        this.forConfirmation = selectedType.forConfirmation;
        this.forAmendment = selectedType.forAmendment;
        this.forContactClient = selectedType.forContactClient;
        this.forCancel = selectedType.forCancel;
        this.forQuotation = selectedType.forQuotation;
        this.forVoucher = selectedType.forVoucher;
        this.forOther = selectedType.forOther;
        this.forWeb = selectedType.forWeb;
      }
    },
  },

  apollo: {
    supplierItineraryNoteTypes: {
      query: LIST_QUERY,
      fetchPolicy: "network-only",
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/itineraries/supplier-notes/SupplierItiNoteEditDialog.vue